<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
      <el-button-group class="float-right">
        <router-link to="/iptal/makbuzlog" tag="button" class="el-button YeniBtn el-button--primary el-button--small">
          Makbuz İptal Log
        </router-link>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-row :gutter="24">
        <el-col :span="19">

          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            ref="multipleTable"
            class="table-xs"
            :data="tableData"
            :height="Height">
            <el-table-column
              label="Tür"
              prop="TurText"
              width="150">
            </el-table-column>
            <el-table-column
              label="Makbuz No"
              width="100">
              <template slot-scope="scope">
                <a @click="Islem(scope.row.mNo)">
                  <span>{{ scope.row.mNo }}</span>
                </a>
              </template>
            </el-table-column>
            <el-table-column
              label="Muhatap"
              prop="Muhatap"
              width="300">
            </el-table-column>
            <el-table-column
              label="Kasa"
              prop="Kasa"
              width="200">
            </el-table-column>
            <el-table-column
              label="Açıklama"
              prop="Aciklama">
            </el-table-column>

          </el-table>
        </el-col>
        <el-col :span="5">
          <div class="raporbloksabitle">
            <el-collapse class="Filtre" v-model="FiltreCollapse">
              <el-collapse-item :title="Sayfa.FiltreAdi" name="1">

                <el-form :rules="FormHata" :model="Form"
                         @submit.prevent.native="Getir"
                         ref="FiltreForm">
                  <el-form-item label="Makbuz No" prop="Makbuz No">
                    <el-input v-model="Form.mNo"></el-input>
                  </el-form-item>
                  <div v-if="!Form.mNo">
                    <el-form-item label="Türü" prop="Tur">
                      <el-select v-model="Form.Tur" filterable>
                        <el-option label="Tahsilat Makbuzu" :value="1"></el-option>
                        <el-option label="Devir Alındısı" :value="2"></el-option>
                        <el-option label="Tediye Fişi" :value="3"></el-option>
                        <el-option label="Tahsilat Fişi" :value="4"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="Site / Bina" prop="Bina_id">
                      <el-select v-model="Form.Bina_id" filterable>
                        <el-option-group
                          label="Site Listesi">
                          <el-option
                            v-for="item in Siteler"
                            :key="item.id"
                            :label="item.Adi"
                            :value="item.id">
                          </el-option>
                        </el-option-group>
                        <el-option-group
                          label="Bina Listesi">
                          <el-option
                            v-for="item in Binalar"
                            :key="item.id"
                            :label="item.Adi"
                            :value="item.id">
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="İşlem Tarih Aralığı" prop="Tarih">
                      <el-date-picker
                        v-model="Form.Tarih"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="Başlangıç Tarihi"
                        end-placeholder="Bitiş Tarihi"
                        format="dd.MM.yyyy"
                      >
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Kasa" prop="Kasa_id">
                      <el-cascader
                        collapse-tags
                        :props="{ multiple: false}"
                        :options="Kasalar"
                        v-model="Form.Kasa_id"
                        filterable></el-cascader>
                    </el-form-item>
                  </div>

                  <el-button type="primary" class="btn-block" size="medium" @click="Getir()"
                             icon="el-icon-check"><span v-if="Form.mNo">Makbuz Görüntüle</span> <span v-if="!Form.mNo">Makbuzları Getir</span>
                  </el-button>
                </el-form>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
      </el-row>
    </div>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="ModalKapat"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>
</template>

<script>

  import MakbuzDetay from "../../components/Pack/Vezne/MakbuzDetay";
  import Yukleniyor from "../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor, MakbuzDetay},
    data() {
      return {
        FiltreCollapse: '1',
        lo: false,
        Yetki: false,
        Kaydet: false,
        Height: window.innerHeight - 100,
        Sayfa: {
          Adi: 'Makbuz İptal',
          ButtonAdi: 'Uygula',
          FiltreAdi: 'Filtreleme',
        },
        Form: {
          Bina_id: null,
          Tarih: [],
          mNo: null,
          Kasa_id: null,
          Tur: 1,
        },
        FormHata: {
          Tur: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        MakbuzDetayModal: false,
        mNo: null,
        Kasalar: [],
        Binalar: [],
        Siteler: [],
        tableData: [],
        tableDisplay: false,

      }
    },
    methods: {

      Islem(mNo) {
        this.mNo = mNo;
        this.MakbuzDetayModal = true;
      },
      ModalKapat() {
        this.mNo = null;
        this.Form.mNo = null;
        this.MakbuzDetayModal = false;
        this.Getir();

      },
      Getir() {

        if (this.Form.mNo) {
          this.FormHata = {
            Tur: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          }
        }
        if (!this.Form.mNo) {
          this.FormHata = {
            Tur: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
            Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
            Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          }
        }
        if (this.Form.mNo) {
          this.Islem(this.Form.mNo);
        } else {
          this.$refs['FiltreForm'].validate((valid) => {
            if (valid) {
              this.lo = true;
              this.$store.dispatch("Post", {...this.Form, path: 'iptal/makbuz/'})
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.tableData = response.Data;
                    this.tableDisplay = true;
                  } else {
                    this.$message.error(response.Mesaj);
                    this.tableDisplay = false;
                  }
                })
            }
          })
        }

      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'muhasebe/kasa'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kasalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

        this.$store.dispatch("Get", {path: 'yonetim/bina'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'yonetim/site'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Siteler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      },
    },
    created() {
      this.SayfaYukle();
      this.Yetki = this.$store.getters.Yetki.iptal == 2 ? true : false;
      var Gun = new Date();
      var AySonu = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
      this.Form.Tarih[0] = Gun;
      this.Form.Tarih[1] = AySonu;
      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
      }
    },

  }
</script>



// WEBPACK FOOTER //
// src/pages/Iptal/makbuz.vue